import { Typography } from 'antd';
import { ChevronRightIcon } from '@/assets/icons/icons';
import type { HelpCategoryArticleRowProps } from '../../types';
import styles from '../../AppHelpCenter.module.scss';

const HelpCategoryArticleRow = ({
  article,
  onSelect,
}: HelpCategoryArticleRowProps) => {
  return (
    <button
      type='button'
      className={styles.categoryArticleRow}
      onClick={() => onSelect(article)}
    >
      <span className={styles.categoryArticleText}>
        <span className={styles.categoryArticleTitleLine}>
          <Typography.Text className={styles.categoryArticleTitle}>
            {article.title}
          </Typography.Text>
          {article.is_new && <span className={styles.helpNewPill}>New</span>}
        </span>
        <span className={styles.categoryArticleTagline}>{article.tagline}</span>
      </span>
      <span className={styles.categoryArticleChevron}>
        <ChevronRightIcon width={16} height={16} fill='currentColor' />
      </span>
    </button>
  );
};

export default HelpCategoryArticleRow;
